import { fetcher } from "helpers/fetcher";

import { TGetParticipantInsuranceRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getStaffParticipantInsurance = async (userId?: string) => {
  return await fetcher<TGetParticipantInsuranceRes, any>(
    ENDPOINT.USER.GET_STAFF_PARTICIPANT_INSURANCE,
    {
      headers: {
        [API_HEADER.VERSION]:
          ENDPOINT.USER.GET_STAFF_PARTICIPANT_INSURANCE.version,
        [API_HEADER.USER_ID]: userId,
      },
    }
  );
};

export const queryGetStaffParticipantInsurance = async (userId?: string) => {
  return (await getStaffParticipantInsurance(userId)).data;
};

queryGetStaffParticipantInsurance._key = (userId?: string) => [
  ENDPOINT.USER.GET_STAFF_PARTICIPANT_INSURANCE.url,
  userId,
];
